import React from 'react'
import ScheduleIcon from '@mui/icons-material/Schedule'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import { DeliveryTimes } from '../../types'
import { useTranslation } from 'react-i18next'
import { formatDate } from '../../utils/utils'

interface DeliveryTimePresentationProps {
  deliveryTimes: DeliveryTimes
  mode: string
}

const DeliveryTimePresentation: React.FC<DeliveryTimePresentationProps> = ({
  deliveryTimes,
  mode,
}) => {
  const { t } = useTranslation('translation')

  let str = ''
  let icon = <></>
  let cssClass = ''

  if (deliveryTimes.xmas !== '') {
    icon = <LocalShippingIcon />

    if (deliveryTimes.xmas === 'advent_too_late') {
      cssClass = 'xmas_delivery_too_late'
      str = t('Lieferung wahrscheinlich nicht mehr zum 01. Dezember.')
    } else if (deliveryTimes.material == 12) {
      cssClass = 'xmas_delivery'
      str = t('Lieferung vor dem 01. Dezember bei Bestellung bis %s').replace(
        '%s',
        deliveryTimes.xmas,
      )
    } else if (deliveryTimes.xmas === 'xmas_too_late') {
      cssClass = 'xmas_delivery_too_late'

      if (mode == 'dates') {
        str = t(
          'Lieferung wahrscheinlich nach Weihnachten. Wenn du mehr als ein Produkt im Warenkorb hast, liefern wir ggf. einzelne Produkte schneller!',
        )
      } else {
        str = t('Voraussichtliche Lieferung nach Weihnachten')
      }
    } else {
      cssClass = 'xmas_delivery'

      // str = t('Pünktlich zu Muttertag bei Bestellung bis %s').replace(
      //   '%s',
      //   deliveryTimes.xmas,
      // )

      str = t('Pünktlich zum 24.12. bei Bestellung bis %s').replace(
        '%s',
        deliveryTimes.xmas,
      )
    }
  } else if (mode == 'days') {
    if (parseInt(deliveryTimes.min) + parseInt(deliveryTimes.max) == 0) {
      str = t('Lieferung sofort')
      icon = <ScheduleIcon />
    } else {
      const days = deliveryTimes.min + '-' + deliveryTimes.max
      str = t('Lieferzeit %s Tage').replace('%s', days)
      icon = <ScheduleIcon />
    }
  } else if (mode == 'dates') {
    icon = <LocalShippingIcon />

    if (deliveryTimes.min == deliveryTimes.max) {
      str =
        t('Voraussichtlicher Liefertermin') +
        ': ' +
        formatDate(deliveryTimes.min)
    } else {
      str =
        t('Voraussichtlicher Liefertermin') +
        ': ' +
        formatDate(deliveryTimes.min) +
        ' - ' +
        formatDate(deliveryTimes.max)
    }
  }

  return (
    <span className={cssClass}>
      {icon} {str}
    </span>
  )
}

export default DeliveryTimePresentation
